import {
  Autocomplete,
  CircularProgress,
  Box,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import ChartByTime from "./ChartByTime";
import { Shirt } from "../../entities/Shirt";

interface ShirtChartProps {
  title?: string;
  options: Array<Shirt>;
  selectedShirt: Shirt | null;
  setSelectedShirt: Function;
  xData: Array<Date>;
  yData: Array<number>;
  valueFormatter?: Function;
  withMonth: boolean;
}

const ShirtChart = ({
  title,
  options,
  selectedShirt,
  setSelectedShirt,
  xData,
  yData,
  valueFormatter,
  withMonth,
}: ShirtChartProps) => {
  const matches = useMediaQuery("(min-width:900px)");

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        rowGap: 1,
        width: "100%",
      }}
    >
      <Box>
        <Typography variant="h4" sx={{ fontWeight: "700px !important" }}>
          {title}
        </Typography>
      </Box>
      <Box>
        {selectedShirt ? (
          xData.length > 0 && yData.length > 0 ? (
            <ChartByTime
              xData={xData}
              yData={yData}
              valueFormatter={valueFormatter}
              withMonth={withMonth}
              showButtons={true}
            />
          ) : (
            <CircularProgress />
          )
        ) : (
          <></>
        )}
      </Box>
      <Box sx={{ boxSizing: "border-box" }}>
        <Autocomplete
          disablePortal
          getOptionLabel={(option: Shirt) =>
            option.title
              ? option.title
              : option.model.team.name + " - " + option.model.season.id
          }
          id="combo-box-demo"
          options={options}
          sx={{ width: matches ? 300 : "100%" }}
          renderInput={(params) => (
            <TextField {...params} label="Select shirt" />
          )}
          value={selectedShirt}
          onChange={(event: any, newValue: Shirt | null) => {
            setSelectedShirt(newValue);
          }}
        />
      </Box>
    </Box>
  );
};

export default ShirtChart;
